// extracted by mini-css-extract-plugin
export default {"card":"UserCard_card__nw55L","roles":"UserCard_roles__ArRzd","buttons":"UserCard_buttons__eq9ON"};